import { SupplierThread } from './types';

/** A supplier has answered once their thread holds a reply or a quote. */
const hasReplied = (thread: SupplierThread): boolean =>
  Boolean(thread.quote) || thread.status === 'replied' || thread.status === 'negotiating';

/** The StepBar's one line: "3 suppliers · 1 replied". */
export const outreachStepSummary = (threads: SupplierThread[]): string => {
  const total = threads.length;
  const replied = threads.filter(hasReplied).length;
  return `${total} supplier${total === 1 ? '' : 's'} · ${replied} replied`;
};
